import { render, staticRenderFns } from "./PolicyInstallment.vue?vue&type=template&id=1a3f11cd&scoped=true"
import script from "./PolicyInstallment.vue?vue&type=script&lang=js"
export * from "./PolicyInstallment.vue?vue&type=script&lang=js"
import style0 from "./PolicyInstallment.vue?vue&type=style&index=0&id=1a3f11cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f11cd",
  null
  
)

export default component.exports